<template>
  <div class="addPro">
    <div class="title">
      <!-- 展商报名 -->
      <p>
        <img :src="banner" class="banner-img" />
      </p>
    </div>
    <div style="padding-bottom:20px">
      <el-row>
        <el-col :span="18" :offset="3">
          <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="singUp" label-position="right" size="small" label-width="150px">

            <!-- <el-form-item label="报名参展" prop="exhId" :rules="{ required:true, trigger: 'change', message: '请选择报名参展'}" >
              <el-select v-model="form.exhId" placeholder="">
                <el-option :label="val.exhName" :value="val.exhID" v-for="(val) in exhibitionList" :key="val.exhID"></el-option>
              </el-select>
            </el-form-item> -->
            <template v-for="(item,ind) in formList.list">
              <template v-if="item.fieldKey != 'alyCountry' && item.fieldKey != 'alyBthType'  && item.fieldKey != 'alyProvince'  && item.fieldKey != 'alyCity' && item.fieldKey != 'alyArea' && item.fieldKey != 'alyCardNum'  && item.fieldKey != 'alyLogo' && item.fieldKey != 'alyPdtType' && item.fieldKey !=='alyQQ'">
                <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                <template v-if="item.fieldKey == 'alyTel' || item.fieldKey == 'alyFax' || item.fieldKey == 'aLyLegalTel' || item.fieldKey == 'aLyLegalFax'">
                  <el-input v-model.trim="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                </template>
                <template v-else-if="item.fieldKey == 'alyWebUrl'">
                  <el-input v-model.trim="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                </template>
                <template v-else-if="item.fieldKey == 'alyComEName' || item.fieldKey == 'alyComName' ||item.fieldKey == 'alyEAddress' || item.fieldKey == 'alyAddress' || item.fieldKey == 'alyPsnName'">
                  <el-input :type=" ( item.fieldKey == 'alyPdtInfo' ) ? 'textarea': 'text'" v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @blur="trimInput(item.fieldKey)"></el-input>
                </template>
                <template v-else>
                   <el-input  :type=" ( item.fieldKey == 'alyPdtInfo' ) ? 'textarea': 'text'"  v-model.trim="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                </template>
                </el-form-item>
              </template>

              <!-- 展位面积 -->
              <template v-if="item.fieldKey == 'alyArea' || item.fieldKey == 'alyCardNum' || item.fieldKey == 'alyQQ'">
                <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                  <el-input   v-model.trim="form[item.fieldKey]" @keyup.native="inputChange($event,item.fieldKey)" :placeholder="item.fieldHolder"></el-input>
                </el-form-item>
              </template>
              <!-- 展位类型 -->
              <template v-if="item.fieldKey == 'alyBthType'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder">
                    <el-option v-for="(item, index) in bthTypeList" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <!-- 产品类型 -->
              <template v-if="item.fieldKey == 'alyPdtType'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder">
                    <el-option :label="val.typName" :value="val.typID" v-for="(val) in classTypeList" :key="val.typID"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'alyCountry'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeCountry' filterable>
                    <el-option v-for="(item, index) in countryList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'alyProvince'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeProvince' :disabled="provinceList.length<=0">
                    <el-option v-for="(item, index) in provinceList" :key="index" :label="item.zptProvince" :value="item.zptProvince"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'alyCity'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey"  :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]"  :placeholder="item.fieldHolder" :disabled="citysList.length<=0">
                    <el-option v-for="(item, index) in citysList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template v-if="item.fieldKey == 'alyLogo'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-input v-model="form[item.fieldKey]" style="display:none"/>
                  <Upload :isFaceRead="false" :mediaUrl.sync="form[item.fieldKey]" :needToken="true"  :typeString = '"E"'/>
                </el-form-item>
              </template>
            </template>
            <!-- 展会负责人信息 -->
            <el-form-item label="展会负责人" prop="PsjName">
              <el-input v-model.trim="form.PsjName" placeholder="请输入展会负责人"></el-input>
            </el-form-item>
            <el-form-item label="负责人手机" prop="PsjMobile">
              <el-input v-model.trim="form.PsjMobile" placeholder="请输入负责人手机"></el-input>
            </el-form-item>
            <el-form-item label="负责人座机" prop="PsjTel">
              <el-input v-model.trim="form.PsjTel" placeholder="请输入负责人座机"></el-input>
            </el-form-item>
            <el-form-item label="负责人职务" prop="PsjRank">
              <el-input v-model.trim="form.PsjRank" placeholder="请输入负责人职务"></el-input>
            </el-form-item>
            <!-- 企业类别 -->
            <el-form-item label="企业类别" prop="alyAtrTrade">
              <el-select v-model="form.alyAtrTrade" placeholder="请选择企业类别">
                <el-option :label="val.dctName" :value="val.dctID" v-for="(val) in companyCategoryList" :key="val.id"></el-option>
              </el-select>
            </el-form-item>
            <!-- <div style='text-align:center'><el-checkbox v-model="registerFlan" @change="changeCheck"><span style="text-decoration:underline;color:#409EFF">注册协议</span></el-checkbox></div> -->
            <div style="text-align:center; padding: 18px 0;">
              <el-button :style="buttonStyle" size="medium" type="primary" @click="onSubmit" :disabled='subimtStatu'>提交</el-button>
            </div>
          </el-form>
          <div class="registBox" v-if="showRegistText" >
            <div class="registContent">
              <div class="icon" @click="closeTip"><i class="el-icon-close"></i></div>
              <p class="smallTitle"> 注册协议</p>
              <p> 【审慎阅读】您在申请注册流程中点击同意前，应当认真阅读以下协议。请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</p>
              <p> 1、与您约定免除或限制责任的条款；</p>
              <p> 2、与您约定法律适用和管辖的条款；</p>
              <p> 3、其他以粗体下划线标识的重要条款。</p>
              <p> 如您对协议有任何疑问，可向平台客服咨询。</p>
              <p> 【特别提示】当您按照注册页面提示填写信息、阅读并同意协议且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容。如您因平台服务与淘宝发生争议的，适用《平台服务协议》处理。如您在使用平台服务过程中与其他用户发生争议的，依您与其他用户达成的协议处理。</p>
              <p> 阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。</p>
              <p> 隐私权政策</p>
              <p> 法律声明</p>
            </div>

          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '@/utils/tools.js';
import Upload from '@/components/Upload'
import { validateComName, validateName, validateRank, validateAddress, validateWebUrl, validateEnCompany, validateChineseZipCode,validateTelele,validatePassword, validateEmail,validateMobile,validateCoutry01 ,} from '@/utils/validator'
import banner from '@/assets/banner.png'
export default {
  components: {
    Upload
  },
  data () {
    return {
      banner: banner,
      exhId: `${this.$route.query.ExhID}` === 'undefined' ? '' : `${this.$route.query.ExhID}`,
      formList:{
        list:[]
      },
      form:{
        alyID: '',
        alyProvince: '',
        alyCity: '',
        alyCardNum: 0,
        exhId: '',
        alyAtrTrade: '',
        PsjName: '',
        PsjMobile: '',
        PsjTel: '',
        PsjRank: ''
      },
      actorRules: {},
      countryList: [],
      provinceList: [],
      citysList: [],
      bthTypeList: ['标摊', '光地'],
      rules:{
        PsjMobile: [{ required: false, trigger: 'blur', message: '请输入正确的负责人手机', validator: validateMobile }],
        PsjTel: [{ required: false, trigger: 'blur', message: '请输入正确的负责人座机', validator: validateTelele }],
        alyAtrTrade: [{ required: true, trigger: 'change', message: '请选择企业类别'}]
      },
      subimtStatu:false,
      registerFlan:false,
      showRegistText:false,
      loading:'',
      classTypeList:[],
      companyCategoryList: [],
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      exhibitionList:[{
        exhName: "植保",
        exhID: 10815
      },{
        exhName: "肥料",
        exhID: 10816
      },{
        exhName: "农化装备及植保器械",
        exhID: 10817
      },{
        exhName: "农业科技",
        exhID: 10818
      }]
    }
  },
  mounted() {
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    // this.getexhibitionlist()
    this.getregisterconfig()
    this.getCountrys()
    // 没有国家时直接也允许修改省份和城市
    this.getallprovinces()
    this.getProductType()
    this.getCompanyCategory()
  },
  methods: {
    trimInput(fieldKey) {
      // console.log(this.form,'trimInput---')
      this.form[fieldKey] = this.form[fieldKey].trim();
    },
    // 获取关联展会列表
    getexhibitionlist(){
      api.getexhibitionlist().then((res)=>{
        if(res.data.code =='200'){
          // console.log(res.data)
          this.exhibitionList = res.data.data
          // console.log('展会列表：',this.exhibitionList)
        }
      })
    },
    //获取展品分类
    getProductType(){
      api.searchproducttype().then((res)=>{
        if(res.data.code =='200'){
          var _data = res.data.data
          this.classTypeList = _data
        }
      })
    },
    //获取企业类别
    getCompanyCategory(){
      api.getCompanyCategory().then((res)=>{
        if(res.data.code =='200'){
          this.companyCategoryList = res.data.data
        }
      })
    },
    inputChange(ev,val){
      this.form[val] = this.form[val].replace(/[^\d]/g,'');
    },
    validateProvince (rule, value, callback) {
      if (rule.required) { // 如果省份必填
        if (this.form.alyCountry === '中国' || this.form.alyCountry === undefined) { // 已选择中国或没有国家选项
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validateCity (rule, value, callback) {
      if (rule.required) {
        if (this.form.alyProvince) {
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        alyCountry: [{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName}],
        alyProvince:[{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName,validator: this.validateProvince}],
        alyCity:[{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName,validator: this.validateCity}],
        alyZipCode: [{ required: item.required, trigger: 'blur', message: "请输入正确"+item.fieldName, validator: validateChineseZipCode }],
        alyAddress: [{ required: item.required, trigger: 'blur', message: item.fieldName+'请输入6-100个字符', validator: validateAddress}],
        alyLogo: [{ required: item.required, trigger: 'change', message: '请上传'+item.fieldName}],
        alyFax: [{ required: item.required, trigger: 'blur', message: "请输入正确"+item.fieldName,validator: validateTelele}],
        alyTel: [{ required: item.required, trigger: 'blur', message: "请输入正确"+item.fieldName,validator: validateTelele}],
        aLyLegalFax: [{ required: item.required, trigger: 'blur', message: "请输入正确"+item.fieldName,validator: validateTelele}],
        aLyLegalTel: [{ required: item.required, trigger: 'blur', message: "请输入正确"+item.fieldName,validator: validateTelele}],
        alyComName: [{ required: item.required, trigger: 'blur',message: item.fieldName+'请输入4-100个字符', validator: validateComName}],
        alyName: [{ required: item.required, trigger: 'blur',message: item.fieldName+'请输入2-50个中文或英文字符', validator: validateName}],
        alyPosition: [{ required: item.required, trigger: 'blur',message: '请输入正确的'+item.fieldName, validator: validateRank}],
        alyMobile: [{ required: item.required, trigger: 'blur',message: '请输入正确的'+item.fieldName, validator: validateMobile}],
        alyWebUrl: [{ required: item.required, trigger: 'blur',message: '请输入'+item.fieldName}], // , validator: validateWebUrl
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'change'},
        select:{required:item.required, message: '请选择', trigger: 'change',validator:function(rule, value, callback){
          if( value || rule.required ){
              if (value == '') {
                callback(new Error('请选择'+item.fieldName))
              } else {
                callback()
              }
          }else{
              callback()
          }
        }},
        alyEmail: [{ required: item.required, trigger: 'blur', message: "请输入正确"+item.fieldName, validator: validateEmail}],
      }
      switch (item.fieldKey){
        case 'alyCountry':
          temp = 'alyCountry'
          break;
        case 'alyProvince':
          temp = 'alyProvince'
          break;
        case 'alyCity':
          temp = 'alyCity'
          break;
        case 'aLyLegalEmail':
        case 'alyEmail':
          temp = 'alyEmail'
          break;
        case 'alyLegalZipCode':
        case 'alyZipCode':
          temp = 'alyZipCode'
          break;
        case 'alyLegalRank':
        case 'alyPosition':
          temp = 'alyPosition'
          break;
        case 'alyLegalMobile':
        case 'alyMobile':
          temp = 'alyMobile'
          break;
        case 'alySName':
        case 'alyWebUrl':
          temp = 'alyWebUrl'
          break;
        case 'alyComName':
        case 'alyComEName':
            temp = 'alyComName'
            break;
        case 'aLyLegal':
        case 'alyPsnName':
            temp = 'alyName'
            break;
        case 'aLyLegalFax':
        case 'aLyLegalTel':
        case 'alyTel':
        case 'alyFax':
            temp = item.fieldKey
            break;
        case 'aLyLegalAddress':
        case 'alyAddress':
        case 'alyEAddress':
            temp = 'alyAddress'
            break;
        case 'alyPdtType':
          temp = 'select'
          break;
        default: 
            temp = 'other'
            break
      }
      return rulesData[temp]
    },
    // 获取城市选项
    getCitys() {
      api.getallcitysbyprovince({
        exhId: this.exhId || sessionStorage.getItem('exhId'),
        zptProvince: this.form.alyProvince
      }).then((res) => {
        this.citysList = res.data.data
      })
    },
    // 获取省份选项
    getallprovinces() {
      api.getallprovinces({
        exhId: this.exhId || sessionStorage.getItem('exhId')
      }).then((res) => {    
        this.provinceList = res.data.data
      })
    },
    //获取国家选项
    getCountrys() {
      api.getallcountrys({
        exhId: this.exhId || sessionStorage.getItem('exhId')
      }).then((res) => {    
        this.countryList = [{zptArea: "国内",zptCity: "中国"}, ...res.data.data]
      })
    },
    //国家切换
    changeCountry(){
      if(this.form.alyCountry !='中国'){
        this.form.alyProvince= ''
        this.form.alyCity =''
        this.provinceList = []
        this.citysList =[]
      } else {
        // 获取省份
        this.getallprovinces()
      }
    },
    //切换省份
    changeProvince() {
      this.form.alyCity =''
      this.getCitys()
    },

    //获取数据
    getregisterconfig(){
      api.getsaasfield({type:"actorapply"}).then(res => {
        if (res.data.code === 200) {
          this.formList.list =[]
          for(var i = 0;i<res.data.data.length;i++){
            if(res.data.data[i].enable == 1){
              this.formList.list.push(res.data.data[i])
            }
          }
          for(var j=0;j<this.formList.list.length;j++){
            this.$set( this.form,this.formList.list[j].fieldKey,'')
          }
          this.loading.close();
        }
      })
    },
    closeTip(){
       this.showRegistText = false
    },
    changeCheck(){
      this.showRegistText = !this.showRegistText
    },
    onSubmit() {
      if( this.subimtStatu ){
        return false
      }
      this.$refs['singUp'].validate((valid) => {
        if (valid) {
          // if(!this.registerFlan){
          //   this.showRegistText = true;
          //   this.$notify({
          //     title: '警告',
          //     message: '请查看注册协议',
          //     type: 'warning'
          //   });
          //   return false
          // }
          this.subimtStatu = true
          var paramt = JSON.parse(JSON.stringify(this.form))
          paramt.exhId =  paramt.exhId.toString()
          // 展会负责人信息以 JSON 字符串形式提交
          if (paramt.PsjName || paramt.PsjMobile || paramt.PsjTel || paramt.PsjRank) {
            paramt.alyLinkJson = JSON.stringify({
              PsjName: paramt.PsjName || '',
              PsjMobile: paramt.PsjMobile || '',
              PsjTel: paramt.PsjTel || '',
              PsjRank: paramt.PsjRank || '',
              PsjType: '展会负责人'
            })
          } else {
            paramt.alyLinkJson = ''
          }
          delete paramt.PsjName
          delete paramt.PsjMobile
          delete paramt.PsjTel
          delete paramt.PsjRank
          api.addactorapply(paramt).then((res) => {
            if (res.data.code == '200') {
              // 提交成功后弹窗提示，点确认按钮关闭后再跳转登录页
              this.$alert(
                '<span class="apply-tip-main">注册成功，组委会将于 1 个工作日内审核。</span>' +
                '<span class="apply-tip-sub">如需加速审核，请联系：</span>' +
                '<span class="apply-tip-item">（设备）<span class="apply-tip-name">罗义燕：</span><span class="apply-tip-tel">13810404772</span></span>' +
                '<span class="apply-tip-item">（农药）<span class="apply-tip-name">马帅帅：</span><span class="apply-tip-tel">13521002358</span></span>' +
                '<span class="apply-tip-item">（农药）<span class="apply-tip-name">宋艳：</span><span class="apply-tip-tel">18618406373</span></span>',
                '提示',
                {
                  confirmButtonText: '确定',
                  type: 'success',
                  dangerouslyUseHTMLString: true,
                  customClass: 'apply-msgbox',
                  callback: (action) => {
                    this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
                  }
                }
              )
            }
            // 失败提示由 api/index.ts 全局响应拦截器统一处理
            this.subimtStatu = false
          })

        } else {
          // this.$notify({
          //   title: '请检查表单填写项是否符合规范！',
          //   type: 'error'
          // })
          return false
        }
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.addPro {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}
.banner-img {
  width: 100%;
  max-width: 900px;
  height: auto;
  display: inline-block;
}
.registBox{
  position: fixed;
  left:0;
  right:0;
  bottom:0;
  top:0;
  z-index: 99;
  overflow-y: auto;
}
.registBox .icon{
  position: absolute;
  right:0;
  top:0;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
}
.registBox .smallTitle{
  font-size: 18px;
  text-align: center;
  padding-bottom: 10px;
  font-weight: bold;
}
.registContent{
  font-size: 14px;
  position: absolute;
  width:650px;
  background: #fff;
  margin:auto;
  top:30%;
  left:0;
  right:0;
  padding:20px;
  border:2px solid #dedede;
}
.registContent p{
  padding: 4px 0;
}
.title{
  text-align: center;
  font-size: 30px;
}
/* 注册成功弹窗内容 */
.apply-msgbox .el-message-box__message p {
  margin: 0;
}
.apply-msgbox .apply-tip-main {
  display: block;
  font-size: 15px;
  line-height: 1.5;
  color: #303133;
}
.apply-msgbox .apply-tip-sub {
  display: block;
  margin-top: 12px;
  font-size: 13px;
  color: #909399;
}
.apply-msgbox .apply-tip-item {
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #606266;
}
.apply-msgbox .apply-tip-name {
  min-width: 3em;
  text-align: justify;
  text-align-last: justify;
}
.apply-msgbox .apply-tip-tel {
  margin-left: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.blue {
  color: #409eff;
}
.col-1-fix {
  padding-left: 0 !important;
}
.desc{
  font-size: 14px;
  line-height: 18px;
  padding: 10px;
}
.mz{
  font-size:14px;
  color:#999;
}
.btns{
  text-align: center;
  padding-top: 15px;
}
.el-checkbox__inner{
  border:2px solid #409eff !important;
}

/* ===== 平板适配 (768px ~ 1024px) ===== */
@media screen and (max-width: 1024px) {
  .addPro {
    padding: 0 10px;
  }
  .banner-img {
    width: 90%;
  }
}

/* ===== 移动端适配 (<=768px) ===== */
@media screen and (max-width: 768px) {
  .addPro {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .title {
    font-size: 20px;
  }
  .banner-img {
    width: 100%;
  }

  /* 表单列占满整行 */
  .addPro .el-col-18 {
    max-width: 100%;
    flex: 0 0 100%;
    width: 100%;
    margin-left: 0 !important;
    padding: 0;
  }
  .addPro .el-col-offset-3 {
    margin-left: 0 !important;
  }

  /* 表单标签改为顶部排列 */
  .addPro .el-form {
    label-width: auto !important;
  }
  .addPro .el-form-item {
    display: block;
    margin-bottom: 18px;
  }
  .addPro .el-form-item__label-wrap {
    margin-left: 0 !important;
  }
  .addPro .el-form-item__label {
    display: block;
    width: 100% !important;
    text-align: left;
    padding-bottom: 4px;
    float: none;
    font-size: 14px;
  }
  .addPro .el-form-item__content {
    margin-left: 0 !important;
    width: 100%;
  }

  /* 输入框 / 选择器占满宽度 */
  .addPro .el-input,
  .addPro .el-select,
  .addPro .el-textarea {
    width: 100% !important;
  }
  .addPro .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0 12px;
    text-align: left;
  }
  .addPro .el-select {
    width: 100% !important;
  }
  .addPro .el-select .el-input {
    width: 100% !important;
  }

  /* 提交按钮 */
  .addPro .el-button--medium {
    width: 80%;
    max-width: 300px;
    padding: 12px 0;
    font-size: 16px;
  }

  /* 注册协议弹窗 */
  .registContent {
    width: 85%;
    top: 20%;
    padding: 15px;
    font-size: 13px;
    max-height: 70vh;
    overflow-y: auto;
  }

  /* 注册成功确认弹窗 */
  .apply-msgbox {
    width: 80% !important;
    max-width: 300px;
  }
  .apply-msgbox .el-message-box__title {
    font-size: 15px;
  }
  .apply-msgbox .el-message-box__message {
    font-size: 13px;
  }
}

/* ===== 小屏手机适配 (<=540px) ===== */
@media screen and (max-width: 540px) {
  .addPro {
    padding: 0 8px;
  }
  .title {
    font-size: 18px;
  }
  .addPro .el-form {
    margin-top: 15px !important;
  }
  .addPro .el-form-item {
    margin-bottom: 14px;
  }
  .addPro .el-form-item__label {
    font-size: 13px;
  }
  .addPro .el-form-item__error {
    position: relative;
    top: 0;
    padding-top: 2px;
    font-size: 12px;
  }
  .addPro .el-radio-group {
    label {
      padding: 6px 0;
    }
  }
  .dash-upload {
    width: 150px;
  }
  .noRequire .el-form-item__label::before {
    content: '';
    display: inline-block;
    width: 10px;
  }
  .registContent {
    width: 90%;
  }

  .apply-msgbox {
    width: 85% !important;
    max-width: 260px;
  }
  .apply-msgbox .el-message-box__title {
    font-size: 14px;
  }
}
</style>
